import React from "react";
import { PropTypes } from "prop-types";
import { Link, ResponsiveImage } from "@quintype/components";
import "./collection-hero-image.m.css";
import { getSlug } from "../../../utils/utils";

const CollectionHeroImage = ({ collection, config }) => {
  const collectionSlug = (collection && getSlug(collection, config)) || "";
  const collectionHeroImageS3key =
    collection.metadata["cover-image"] && collection.metadata["cover-image"]["cover-image-s3-key"];

  if (!collectionHeroImageS3key) {
    return null;
  }

  return (
    <Link href={collectionSlug}>
      <div styleName="collection-hero">
        <ResponsiveImage alt={collectionHeroImageS3key} slug={collectionHeroImageS3key} aspectRatio={[9, 16]} />
        <div styleName="overlay-contents">
          <h2>{collection.summary}</h2>
        </div>
      </div>
    </Link>
  );
};

CollectionHeroImage.propTypes = {
  collection: PropTypes.object,
  config: PropTypes.object,
};

export { CollectionHeroImage };
